export default __webpack_public_path__ + "img/add-link.ecc131d9.svg";